import { useState, useEffect } from "react";

import { calculateChargeDuration } from "../utils/calculations";
import { formatDate } from "../utils/formats";

import { getTransactions } from "../services/clearing/transactions";

const useTransactions = (stationId, currentYear, currentMonth) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const data = await getTransactions(
          stationId,
          currentYear,
          currentMonth
        );

        if (!data || data?.length === 0) {
          setTransactions([]);
          return;
        }

        const mappedTransactions =
          data?.map((item) => {
            const tzMatch = item?.startDateTime?.match(/([+-]\d{2}:\d{2}|Z)$/);
            const timezone = tzMatch ? (tzMatch[1] === "Z" ? "UTC" : tzMatch[1]) : null;

            return {
              id: item?.cdrId,
              transactionId: item?.cdrId,
              chargeDuration: calculateChargeDuration(
                item?.startDateTime,
                item?.endDateTime
              ),
              chargedAmount:
                !item?.freeCharge
                  ? Number.isFinite(item?.totalCostExcludingFee)
                    ? `€${item.totalCostExcludingFee.toFixed(2)}`
                    : "€0.00"
                  : "Free",
              chargedAmountWithFee:
                !item?.freeCharge
                  ? Number.isFinite(item?.totalCost)
                    ? `€${item.totalCost.toFixed(2)}`
                    : "€0.00"
                  : "Free",
              energy: item?.totalEnergy,
              date: formatDate(item?.startDateTime),
              timezone,
              status: item?.freeCharge ? "Free" : "Paid",
              chargingstationName: item?.chargingStationName || "Unknown Station",
              energyCost: Number.isFinite(item?.totalEnergyCost)
                ? `€${item.totalEnergyCost.toFixed(2)}`
                : "€0.00",
              blockingCost: Number.isFinite(item?.totalBlockingCost)
                ? `€${item.totalBlockingCost.toFixed(2)}`
                : "€0.00",
            };
          }) || [];

        setTransactions(mappedTransactions);
      } catch (error) {
        console.error(error);
        setTransactions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [stationId, currentYear, currentMonth]);

  return { transactions, setTransactions, loading };
};

export default useTransactions;
